// extracted by mini-css-extract-plugin
export default {"cta-wrapper":"carousel-child-module__cta-wrapper___p3dvQ","cta":"carousel-child-module__cta___OIesG","container":"carousel-child-module__container___CxgkY"};